$(document).ready(function() {
	if(!document.querySelector('.GPC0150')) return false;
	const GPC0150 = {
		el: null,
		opt: {
            infinite: false,
    		listStyle: true,
    		slidesToShow: 4,
    		slidesToScroll: 1,
    		arrows : true,
    		dots: false,
    		responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
		                arrows: true
					}
				},
				{
					breakpoint: 768,
					settings: {
						autoplay: false,
						slidesToShow: 2,
						slidesToScroll: 1,
						arrows: true
					}
				},
				{
					breakpoint: 414,
					settings: {
						autoplay: false,
						slidesToShow: (320-54)/180,
						slidesToScroll: 1,
						arrows: true
					}
				}
			],
			prevArrow: carouselOptions.bigAnglePrev, // common.js variable
			nextArrow: carouselOptions.bigAngleNext // common.js variable
		},
		template: null,
		init: function(){
			const els = document.querySelectorAll('.GPC0150');
			for (var i = 0; i < els.length; i++) {
				this.el = els[i];
				if($(this.el).find('.contents-template').length>0) {
					this.template = $(this.el).find('.contents-template').clone();
				}
				$(this.el).find('.contents-template').remove();

				// get Recently products
				const _recentlyModelsList = this.el.querySelector('input[name="recentlyModelsList"]');
				if(_recentlyModelsList) {
					const $nav = $('.navigation');
					const list = ($nav && $nav.hasClass('b2b')) ? getCookie("LG5_B2B_RecentlyView") : getCookie("LG5_RecentlyView"),
						$content = $(_recentlyModelsList).closest(".component-outer-box");
					_recentlyModelsList.value = list ? list : "";

					if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
						if(list == undefined) {
							// $content.find("form").remove();
							// no cookies, remove GPC0150 (except admin)
							if(!$('body').hasClass('iw-fullscreen-edit') && !$('.GPC0150').has('.iframe-container')) {
								$(this.el).remove();
							}
						}else {
							this.addEvent();
						}
					} else {
						ePrivacyCookies.view('load', '', $content);
					}
				}
			}
		},
		createProductItem: function(productList, productMessages){
			let html = [];
			for (var i = 0; i < productList.length; i++) {
				let p = productList[i],
					template = $(GPC0150.template).clone().html();
				template = template.replace(/\*modelId\*/g, p.modelId)
								.replace(/\*modelName\*/g, p.modelName)
								.replace(/\*imageAltText\*/g, (p.imageAltText != null) ? p.imageAltText : '')
								.replace(/\*userFriendlyName\*/g, p.userFriendlyName == null ? '' : p.userFriendlyName.replace(/\"/g, "''"))
								.replace(/\*salesModelCode\*/g, p.salesModelCode)
								.replace(/\*modelUrlPath\*/g, p.modelUrlPath)
								.replace(/\*mediumImageAddr\*/g, p.mediumImageAddr)
								.replace(/\*smallImageAddr\*/g, p.smallImageAddr)
								;

				const $template = $(template);
				template = $template.get(0).outerHTML;
				html += template;
			}
			return html;
		},
		addEvent: function(){
			$(this.el).on({
				submit: function(e){
					e.preventDefault();

					const url = e.currentTarget.action,
							param = encodeURI(xssfilter($(e.currentTarget).serialize()));
					const $target = $(e.currentTarget).siblings('.list-contents-wrap');
					const $form = $(e.currentTarget);

					// paramURL, param, type, callback, sType, progressiveTarget, async
					ajax.noCacheCall(url, param, 'json', function(d){
						let data, html;
						if(d && d.data) data = d.data instanceof Array ? d.data[0] : d.data;

						if(d.status == "success" && (data && (data.productList && data.productList.length > 0))) {
							// making markup
							html = GPC0150.createProductItem(data.productList, data.productMessages);
							$target.find('.product-list').html(html);
							$target.find('.product-list').slick(GPC0150.opt);
							$target.addClass('initialized');
							bindImgError();
							$form.trigger('ajaxLoadEnd');
						}else {
							$(GPC0150.el).remove();
							$form.trigger('ajaxLoadEnd');
						}
					}, 'post', null); // LGCOMSPEED-6: 로딩스피너 제거(노출 불필요)
				}
			}, 'form');

			const targetForm = $(this.el).find('form');
			targetForm.submit();
		}
	};
	GPC0150.init();
});